import { OnSuccessCallback, useCustomMutation } from './index';
import { QueryError } from '../queries';
import Config from '../../config';
import { METHODS } from '../constants';

export const useBatchRefreshTaxBookingEntities = (
  onSuccess?: OnSuccessCallback<Response, string[]>
) =>
  useCustomMutation<Response, QueryError, string[]>({
    handleData: () => ({
      url: Config.endpoints.REFRESH_TAX_BOOKING_ENTITIES,
      method: METHODS.POST,
    }),
    invalidateKey: [],
    errorMessage: 'Refreshing Tax Booking Entities failed.',
    successMessage: 'Refreshing Tax Booking Entities started. It may take a while',
    onSuccess,
  });
